import { Building2 } from 'lucide-react';

export function EmptyTenantRelationships() {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border-subtle bg-bg-surface/50 px-6 py-16 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-bg-surface-2 mb-4">
        <Building2 className="h-6 w-6 text-text-secondary" />
      </div>
      <h3 className="text-base font-semibold text-text-primary">No customer relationships</h3>
      <p className="mt-2 text-sm text-text-secondary max-w-xs">
        You haven&apos;t been connected to any customers yet. Contact your account manager or wait
        for an invitation from a customer.
      </p>
    </div>
  );
}
